import Modal from "@atomaro/ui-kit/components/Modal/Modal";
import { Button, Input } from "@atomaro/ui-kit";
import { useEffect, useState } from "react";
import { useApiariesStore } from "entities/apiaries";
import { useDictionariesStore } from "entities/dictionaries";
import {
  DictionaryAddContent,
  DictionaryAddFooter,
  DictionaryAddHeaderRow,
  DictionaryAddPopup,
} from "./style";
import { COLORS } from "shared/consts";

export const AddDictionaryModal = ({ isMobile }: { isMobile: boolean }) => {
  const isOpen = useDictionariesStore((s) => s.isOpenModalAddDictionary);
  const closeAddModal = useDictionariesStore((s) => s.closeAddModal);
  const addDictionary = useDictionariesStore((s) => s.addDictionary);

  const currentApiaryId = useApiariesStore((s) => s.currentApiaryId);

  const [name, setName] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [saving, setSaving] = useState<boolean>(false);

  useEffect(() => {
    if (!isOpen) {
      setName("");
      setError("");
      setSaving(false);
      return;
    }
    setError("");
  }, [isOpen]);

  const onSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError("Введите название");
      return;
    }
    if (!currentApiaryId) return;
    setSaving(true);
    try {
      await addDictionary({
        apiaryId: currentApiaryId,
        name: "",
        type: name,
        description: "",
      });
      closeAddModal();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      centered
      style={{ padding: 0 }}
      onClickOverlay={closeAddModal}
      maxWidth={isMobile ? "100vw" : "360px"}
      maxHeight={isMobile ? "100vh" : "auto"}
    >
      <DictionaryAddPopup>
        <DictionaryAddHeaderRow>
          <h3>Новый словарь журнала</h3>
          <Button
            size="s"
            variant="outline"
            colorScheme="neutral"
            onClick={closeAddModal}
            iconPrefix={
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                style={{
                  fill: "none",
                }}
              >
                <rect
                  id="24 / Navigation / Close Large"
                  width="24.000000"
                  height="24.000000"
                  x="0.000000"
                  y="0.000000"
                />
                <path
                  id="Union"
                  d="M10.9401 12.0006L4.99902 17.9417L6.05968 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9417L13.0614 12.0006L19.0025 6.0595L17.9418 4.99884L12.0008 10.9399L6.0597 4.99884L4.99904 6.0595L10.9401 12.0006Z"
                  fill={COLORS.FG.DEFAULT}
                  fillRule="evenodd"
                />
              </svg>
            }
          />
        </DictionaryAddHeaderRow>
        <DictionaryAddContent>
          <Input
            placeholder="Новый словарь"
            name="dictionary-name"
            value={name}
            size="l"
            label="Название"
            error={error}
            onChange={(e) => {
              setName(e.target.value);
              if (error) setError("");
            }}
            disabled={saving}
          />
        </DictionaryAddContent>
        <DictionaryAddFooter isMobile={isMobile}>
          <Button
            size={`${isMobile ? "l" : "m"}`}
            colorScheme="neutral"
            variant="ghost"
            label="Отменить"
            style={{
              width: "100%",
            }}
            onClick={closeAddModal}
            disabled={saving}
          />
          <Button
            size={`${isMobile ? "l" : "m"}`}
            colorScheme="accent"
            label="Сохранить"
            style={{
              width: "100%",
            }}
            onClick={onSave}
            disabled={saving || !name}
          />
        </DictionaryAddFooter>
      </DictionaryAddPopup>
    </Modal>
  );
};
